import { useEffect } from 'react'

export const LongTaskMonitor = ({
  threshold = 20000,
}: {
  threshold?: number
}) => {
  useEffect(() => {
    if (typeof PerformanceObserver === 'undefined') {
      console.warn(
        'Performance monitoring is disabled: PerformanceObserver is not supported.'
      )
      return
    }

    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        if (entry.duration >= threshold) {
          console.warn(`Long task detected`, {
            duration: entry.duration,
            name: entry.name,
            startTime: entry.startTime,
          })
        }
      }
    })

    try {
      observer.observe({ entryTypes: ['longtask'] })
    } catch (err) {
      console.error('Failed to observe longtasks', err)
    }

    return () => observer.disconnect()
  }, [threshold])

  return null
}
